<template>
  <aside class="dashboard-sidebar">
    <nav class="bg-light h-100 border-right">
      <ul class="nav flex-column py-3">
        <li
          v-for="link in links"
          :key="link.name"
          class="nav-item"
        >
          <router-link
            :to="{ name: link.name }"
            class="nav-link"
          >
            {{link.label}}
          </router-link>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
  export default {
    computed: {
      links() {
        return [
          {
            label: 'Users',
            name: 'admin.users',
          },
          {
            label: 'Voucher Codes',
            name: 'admin.voucher-codes',
          },
        ]
      },
    },
  }
</script>

<style lang="scss">
  @import "@/styles/_variables.scss";

 .dashboard-sidebar {
    height: 100%;
    flex: 0 0 200px;

    .nav {
      font-size: 0.75em;
    }

    .nav-link {
      color: $text;
      font-weight: bold;

      &.router-link-active {
        color: $darkSkyBlue;
      }
    }
  }
</style>
